import React from 'react';
import {
  Typography,
  Box,
  IconButton,
  Stack,
  Tooltip
} from '@mui/material';
import { Schedule as ScheduleIcon } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslations } from 'next-intl';
import { type Task } from '../../../../stores/TaskStore';
import { type Tag } from '../../../../stores/TagsStore';
import { useTaskDetailStore } from '@/stores/TaskDetailStore';
import NormalTag from '@/components/ui/Tag';

interface TaskHeaderProps {
  task: Task;
  formatDateTime: (date?: string | Date) => string;
}

export const TaskHeader: React.FC<TaskHeaderProps> = ({ task, formatDateTime }) => {
  const taskDetailStore = useTaskDetailStore();
  const t = useTranslations('TaskManager');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', }}>
      {/* 第一行：返回按钮、标题和创建时间 */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton
          onClick={taskDetailStore.close}
          sx={{
            color: 'var(--color-muted-foreground)',
            '&:hover': {
              backgroundColor: 'var(--color-accent)',
              color: 'var(--color-accent-foreground)'
            }
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: 'var(--color-foreground)',
            wordBreak: 'break-word',
            flexGrow: 1
          }}
        >
          {task.title}
        </Typography>
        <Tooltip title={`${t('createdAt')}: ${formatDateTime(task.createdAt)}`}>
          <IconButton sx={{ color: 'var(--color-muted-foreground)' }}>
            <ScheduleIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* 第二行：标签 */}
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2, pl: '50px' }}>
        {task.tags && task.tags.length > 0 && (
          <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
            {task.tags.map((tag: Tag) => (
              <NormalTag key={tag.id} tag={tag} />
            ))}
          </Stack>
        )}
      </Box>
    </Box>
  );
};